import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Icon from "../../../assets/Icon.svg";
import Chat from "../../../assets/Chat.svg";
import Mindfulness from "../../../assets/Mindfullness.svg";
import Live from "../../../assets/Live.svg";
import Checkin from "../../../assets/Checkin.svg";
import Logout from "../../../assets/Logout.svg";
import api from "../../../axiosconfig.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faKey,
  faGraduationCap,
} from "@fortawesome/free-solid-svg-icons";
import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import BugReportIcon from "@mui/icons-material/BugReport";
import "react-toastify/dist/ReactToastify.css";
import { logout } from "../../../store/authSlice";
import { openBugReport } from "../../../store/bugReportSlice";
import "./Sidebar.css";
import { selectProfileImageUrl } from "../../../store/profileImageSlice.js";
import { isAdminUser } from "../../../utils/userUtils";

const performLogout = async (navigate, dispatch) => {
  console.log("logout");
  try {
    await api.post("/login", { request: "logout" });

    dispatch(logout());

    localStorage.removeItem("completedAssessmentTabs");
    localStorage.removeItem("progress");

    navigate("/");

    console.log("logout complete");
  } catch (error) {
    console.log("Logout failed: ", error);
  }
};

export const SidebarCol = ({ activetab }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const avatarUrl = useSelector(selectProfileImageUrl);
  const user = useSelector((s) => s.auth.user);
  const isAdmin = isAdminUser(user);
  const isActive = (path) => location.pathname.includes(path);

  return (
    <div className="sidebar-collapsed">
      <div className="sidebar-container">
        <div className="header-part">
          {/* Logo Section */}
          <div className="mindsherpa-logo" onClick={() => navigate("/home")} style={{ cursor: 'pointer' }}>
            <img className="icon-mobile" src={Icon} alt="mindsherpa-logo" />
          </div>
          <p className="logo-home-text">Home</p>

          {/* User stats */}
          <div
            className={`home-sidebar ${isActive("/user-statistics") ? "active" : ""}`}
            onClick={() => navigate("/user-statistics")}
          >
            <span className="home" aria-hidden="true">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                focusable="false"
                aria-hidden="true"
              >
                <path
                  fill="currentColor"
                  d="M1.75 13.25V1.5H.5v12a1.24 1.24 0 0 0 1.22 1H15.5v-1.25z"
                />
                <path
                  fill="currentColor"
                  d="M3.15 8H4.4v3.9H3.15zm3.26-4h1.26v7.9H6.41zm3.27 2h1.25v5.9H9.68zm3.27-3.5h1.25v9.4h-1.25z"
                />
              </svg>
            </span>
            <p className="text">User stats</p>
          </div>

          <hr className="line" />

          {/* Main Navigation */}
          <div className="main-part">
            <div
              className={`menu-item ${
                isActive("/assessment-dashboard") ||
                isActive("/Disclaimer") ||
                isActive("/Assessment/maincontent") ||
                isActive("/Question-card") ||
                isActive("/PEARLIReports")
                  ? "active"
                  : ""
              }`}
              onClick={() => navigate("/assessment-dashboard")}
            >
              <img className="menu-icon" src={Checkin} alt="assessment" />
              <p className="menu-text">Assessment</p>
            </div>
            <div
              className={`menu-item ${
                isActive("/sherpa-dashboard") || isActive("/sherpa") ? "active" : ""
              }`}
              onClick={() => navigate("/sherpa")}
            >
              <img className="menu-icon" src={Chat} alt="chat" />
              <p className="menu-text">Sherpa</p>
            </div>
            <div
              className={`menu-item ${
                isActive("/mindfulness") || isActive("/exercises")
                  ? "active"
                  : ""
              }`}
              onClick={() => navigate("/mindfulness")}
            >
              <img className="menu-icon" src={Mindfulness} alt="mindfulness" />
              <p className="menu-text">Mindfulness</p>
            </div>
            <div
              className={`menu-item ${isActive("/live") ? "active" : ""}`}
              onClick={() => navigate("/live")}
            >
              <img className="menu-icon" src={Live} alt="live" />
              <p className="menu-text">Live</p>
            </div>
            <div
              className={`menu-item ${isActive("/courses") ? "active" : ""}`}
              onClick={() => navigate("/courses")}
            >
              <FontAwesomeIcon
                className="menu-icon-fa"
                icon={faGraduationCap}
                alt="admin"
              />
              <p className="menu-text">Courses</p>
            </div>
          </div>

          <hr className="line" />

          {/* Footer: Profile & Logout */}
          <div className="logout-area">
            {isAdmin ? (
              <div
                className={`admin ${isActive("/admin") ? "active" : ""}`}
                onClick={() => navigate("/admin")}
              >
                <FontAwesomeIcon
                  className="admin-icon"
                  icon={faKey}
                  alt="admin"
                />
                <p className="admin-text">Admin Portal</p>
              </div>
            ) : (
              ""
            )}
            {user?.role === "Developer" && (
              <div
                className={`menu-item ${isActive("/dev") ? "active" : ""}`}
                onClick={() => navigate("/dev")}
              >
                <AnalyticsOutlinedIcon className="menu-icon-mui" />
                <p className="menu-text">Dev Portal</p>
              </div>
            )}
            <div
              className={`profile ${isActive("/profile") ? "active" : ""}`}
              onClick={() => navigate("/profile")}
            >
              <img
                className="profile-icon"
                alt="Profile"
                src={avatarUrl || "/pro.png"}
                onError={(e) => {
                  const img = e.currentTarget;
                  img.onerror = null;
                  img.src = "/pro.png";
                }}
              />
              <p className="profile-text">Profile</p>
            </div>
            <div
              className={`logout ${isActive("/logout") ? "active" : ""}`}
              onClick={() => performLogout(navigate, dispatch)}
            >
              <img className="logout-icon" src={Logout} alt="logout" />
              <p className="logout-text">Logout</p>
            </div>
            <div
              className="bug-report-sidebar-btn"
              onClick={() => dispatch(openBugReport())}
              title="Report a Bug"
              aria-label="Report a Bug"
            >
              <div className="bug-report-circle">
                <BugReportIcon sx={{ color: "#ffffff", fontSize: "28px", pointerEvents: "none" }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
